import React, { Component } from 'react';
import CourseMiddleware from '../../store/middleware/courseMiddleware';
import { connect } from 'react-redux';
// import * as firebase from 'firebase'
import CircularProgress from '@material-ui/core/CircularProgress';
import JoinedCourses from "../JoinedCourses/joinedcourses";
import AvailableCourses from "../AvailableCourses/availablecourses";
import Classes from "../Classes/classes";
import ErrorHandler from "../ErrorHandler/errorhandler";
import CourseActions from '../../store/actions/courseActions';

var user;

class Home extends Component {
    constructor() {
        super();
        this.state = {
            courseData: null,
            courseId: [],
            popupOpen: false,
            coursesLoader: true,
            errorPopupOpen: false,
            classesLoader : false,
            classDetails : null,
            networkErrorInJoinClass : false
        }
    }

    componentWillReceiveProps(nextprops) {
        var userProps = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        if (!userProps) {
            this.props.history.push('/');
        }

        if (nextprops.allCourses && !nextprops.loader) {
            this.setState({ coursesLoader: false })
        }

        if (nextprops.isErrorInCourses) {
            this.setState({
                errorPopupOpen: true,
                coursesLoader: false,
            })
        }

        if(nextprops.isErrorInJoinCourse){
            this.setState({
                networkErrorInJoinClass : true,
                classesLoader : false
            })
        }

        if(nextprops.joinCourse && nextprops.joinCourse.classId) {
            var route = this.state.courseData.secondName !== undefined ? this.state.courseData.secondName : this.state.courseData.name.toLowerCase().replace(/\s/g, "-")
            this.props.history.push(`/course/${route}`, {classDetails: this.state.classDetails, course: this.state.courseData, user: this.props.user })
            this.setState({
                classesLoader : false
            })
        }
    }
    
    componentDidMount() {
        if (user && user.email) {
            this.props.courses({
                id: user._id,
                pc_access_token: user.pc_access_token
            })
        }

        if(this.props.allCourses && this.props.allCourses.length ) {
            this.setState({
                coursesLoader : false
            })
        }
    }

    errorPopupClose = () => {
            this.props.courses({ id: this.props.user._id, pc_access_token: this.props.user.pc_access_token })
            this.props.coursesClear()
            this.setState({
                coursesLoader: true,
                errorPopupOpen: false
            })
    }

    componentWillUnmount() {
        this.props.clearmodule()
    }

    checkClass(data) {
        this.setState({
            courseData: data,
            popupOpen: true
        })
    }

    popupClose() {
        this.setState({ popupOpen: false });
    }

    getCourseId(data) {
        let id = this.state.courseId
        id.push(data)
        this.setState({
            courseId: id
        })
    }

    joinClass(data) {
        this.props.joincourse({ id: this.props.user._id, classId: data._id, courseId: this.state.courseData._id })
        this.props.joinCourseClear()
        this.setState({
            classesLoader : true,
            classDetails : data
        })
    }

    // logout() {
    //     this.props.logout();
    // }

    render() {
        user = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        return (
            <div> {this.state.coursesLoader ?
                <div style={{ flexDirection: "column", display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}><CircularProgress size={100} thickness={3} style={{color : "#13a89e"}} /></div> :
                <div>
                    {!this.state.errorPopupOpen ?
                        <div style={{ position: "absolute", left: "5%", top: "15%", right: "5%" }}>
                            <div style={{ width: "100%", float: "left" }}>
                                <h3 style={{ fontWeight: "bold", color: "#13a89e", fontSize: "24px", lineHeight: 1.1 }}>
                                    Welcome, {user ? user.name : ""}!
                            </h3>
                            </div>

                            <JoinedCourses
                                joinedCourses={this.props.joinedCourses}
                                courseId={this.getCourseId.bind(this)}
                                user={user}
                            />

                            <AvailableCourses
                                allCourses={this.props.allCourses}
                                courseId={this.state.courseId}
                                checkClass={this.checkClass.bind(this)}
                            />

                            {this.state.popupOpen ?
                                <Classes
                                    classesLoader = {this.state.classesLoader}
                                    popupOpen={this.state.popupOpen}
                                    popupClose={this.popupClose.bind(this)}
                                    courseData={this.state.courseData}
                                    user={user}
                                    joinClass={this.joinClass.bind(this)}
                                    networkErrorInJoinClass = {this.state.networkErrorInJoinClass}
                                />
                                : ""}
                        </div> :
                            <ErrorHandler
                                errorPopupOpen={this.state.errorPopupOpen}
                                errorPopupClose={this.errorPopupClose.bind(this)}
                            />
                    }
                </div>
            }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        // state: state,
        user: state.authReducer.user,
        loader: state.courseReducer.isLoading,
        allCourses: state.courseReducer.courses.allCourses,
        // allCoursesFailed: state.courseReducer.recommendedCoursesError,
        joinedCourses: state.courseReducer.courses.joinedCourses,
        isErrorInCourses: state.courseReducer.isErrorInCourses,
        joinCourse : state.courseReducer.joinCourse,
        isErrorInJoinCourse : state.courseReducer.isErrorInJoinCourse,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        // logout: () => dispatch(AuthMiddleware.logoutMiddleware()),
        // user: (user) => dispatch(AuthActions.Signin(user)),
        courses: (data) => dispatch(CourseMiddleware.coursesMiddleware(data)),
        coursesClear: () => { dispatch(CourseActions.Courses()) },
        joincourse: (data) => dispatch(CourseMiddleware.joinCourseMiddleware(data)),
        joinCourseClear: () => {dispatch(CourseActions.JoinCourse())},
        clearmodule: () => { dispatch(CourseActions.Modules()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);


// WEBPACK FOOTER //
// ./src/container/Home/home.js